import React from 'react';

const PRODUCT = __PRODUCT__; // eslint-disable-line no-undef
/* eslint-disable import/no-dynamic-require */
const Error404 = require(`./${PRODUCT}/404`);
/* eslint-enable import/no-dynamic-require */

const ErrorManager = () => <Error404 />;

ErrorManager.propTypes = {};

module.exports = ErrorManager;



// WEBPACK FOOTER //
// ./routes/404/components/ErrorManager.js